module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"setRecommendationSettingsCard.title":"Configure Recommendation Settings","setRecommendationSettingsCard.enabled":"Enabled"}}')
  delete Component.options._Ctor
}
